<template>
  <v-data-table :headers="headers" :items="items" disable-pagination hide-default-footer>
    <template v-slot:item.no="{ index }">
      {{ index + 1 }}
    </template>
    <template v-slot:item.invoiceAmount="{ item }">
      {{ formatPrice(item.invoiceAmount) }}
    </template>
    <template v-slot:item.ppn="{ item }">
      {{ formatPrice(item.ppn) }}
    </template>
    <template v-slot:item.payment="{ item }">
      {{ formatPrice(item.payment) }}
    </template>
    <template v-slot:item.balance="{ item }">
      {{ formatPrice(item.balance) }}
    </template>
    <template v-slot:body.append="{}">
      <tr>
        <td colspan="5">TOTAL</td>
        <td style="border: 1px">
          {{ formatPrice(totalInvoice) }}
        </td>
        <td style="border: 1px">
          {{ formatPrice(totalPPN) }}
        </td>
        <td style="border: 1px">
          {{ formatPrice(totalPayment) }}
        </td>
        <td style="border: 1px">
          {{ formatPrice(totalBalance) }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "reconciliation-detail-ap",
  props: {
    items: Array,
  },
  data() {
    return {
      headers: [
        {
          id: 1,
          text: "No",
          align: "center",
          sortable: false,
          value: "no",
          divider: true,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Invoice #",
          value: "invoiceNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 2,
          text: "Invoice Date",
          value: "invoiceDate",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "PO#",
          value: "poNumber",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Vendor",
          value: "vendor",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Invoice Amount",
          value: "invoiceAmount",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "PPN",
          value: "ppn",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Payment",
          value: "payment",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
        {
          id: 3,
          text: "Balance",
          value: "balance",
          sortable: false,
          class: "light-blue lighten-2 font-weight-black",
        },
      ],
    };
  },
  computed: {
    totalInvoice() {
      return this.items.reduce((acc, item) => {
        return acc + item.invoiceAmount;
      }, 0);
    },
    totalPPN() {
      return this.items.reduce((acc, item) => {
        return acc + item.ppn;
      }, 0);
    },
    totalPayment() {
      return this.items.reduce((acc, item) => {
        return acc + item.payment;
      }, 0);
    },
    totalBalance() {
      return this.items.reduce((acc, item) => {
        return acc + item.balance;
      }, 0);
    },
  },
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>

<style></style>
